import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

import { PhotoThumbnails } from '../../../../../../consumer/graphql/fragments/global';
import { AlbumRootAlbumFolderBaseDetails } from '../../../../../../../graphql/fragments/album';

export const getAlbumMembershipGroupRootQuery = gql`
  query getAlbumMembershipGroupRoot($id: RecordID!) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      album {
        id
        name
        ...AlbumRootAlbumFolderBaseDetails
      }
      album_folder {
        id
      }
    }
  }
  ${AlbumRootAlbumFolderBaseDetails}
`;

const getAlbumMembershipGroupRootOptions = {
  options: ({ albumMembershipGroupId }) => ({
    variables: {
      id: albumMembershipGroupId,
    },
    fetchPolicy: 'cache-first',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

export const getAlbumMembershipGroupRoot = graphql(
  getAlbumMembershipGroupRootQuery,
  getAlbumMembershipGroupRootOptions,
);

export const getAlbumMembershipGroupNavigationQuery = gql`
  query getAlbumMembershipGroupNavigation(
    $id: RecordID!
    $limit: Int = 99
    $offset: Int = 0
  ) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      display_name
      album_memberships_collection(slice: { limit: $limit, offset: $offset }) {
        total
        count
        records {
          id
          matched_photos_extended {
            total
            records {
              id
              photo {
                ...PhotoThumbnails
              }
            }
          }
          album {
            id
            name
            last_uploaded_at
            slideshow {
              status
            }
            custom_prints_meta(custom_print_types: [WALDOGRAM]) {
              onsite_delivery_enabled
              offsite_shipping_enabled
            }
            photos(use_all_photos_mode: true) {
              total
            }
          }
          cover_photos {
            records {
              ...PhotoThumbnails
            }
          }
        }
      }
    }
  }
  ${PhotoThumbnails}
`;

const getAlbumMembershipGroupNavigationOptions = {
  options: ({ albumMembershipGroupId }) => ({
    variables: {
      id: albumMembershipGroupId,
    },
    fetchPolicy: 'cache-first',
  }),
  skip: ({ albumMembershipGroupId }) => !albumMembershipGroupId,
};

const getAlbumMembershipGroupNavigation = graphql(
  getAlbumMembershipGroupNavigationQuery,
  getAlbumMembershipGroupNavigationOptions,
);

export default getAlbumMembershipGroupNavigation;
